export default __webpack_public_path__ + "static/media/Poppins-SemiBoldItalic.cc7ee35c.ttf";